import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M6 16.326A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 .5 8.973",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "m13 12-3 5h4l-3 5", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "CloudLightning";
const CloudLightning = memo(themed(Icon));
export {
  CloudLightning
};
//# sourceMappingURL=cloud-lightning.js.map
